import type { RootState } from 'features/app/store/store';

export const isMicrophoneMutedSelector = (state: RootState) => {
  return state.audio.isMicrophoneMuted;
};

export const selectVoiceMeetingStatus = (state: RootState) => {
  return state.audio.voiceMeetingStatus;
};
